import { EnvironmentService } from '../environment-service/environment.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../environment-service/environment.service";
var BuildHealthService = /** @class */ (function () {
    function BuildHealthService(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
    }
    BuildHealthService.prototype.getBuilds = function (numberOfBuilds, beginDate, endDate) {
        var url = this.environmentService.getApiRoot() + 'vsts/builds/health';
        var body = {
            numberOfBuilds: numberOfBuilds,
            isoBeginDate: beginDate.toISOString(),
            isoEndDate: endDate.toISOString()
        };
        return this.http.post(url, body);
        //.pipe(catchError(this.handleError<any>('getting build health')));
    };
    BuildHealthService.ngInjectableDef = i0.defineInjectable({ factory: function BuildHealthService_Factory() { return new BuildHealthService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService)); }, token: BuildHealthService, providedIn: "root" });
    return BuildHealthService;
}());
export { BuildHealthService };
